import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import socketMiddleware from "../utils/useSocket ";

const store = configureStore({
    reducer:rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(
        {
            immutableCheck: false, // Disable ImmutableStateInvariantMiddleware
            serializableCheck: false, // Disable SerializableStateInvariantMiddleware
          }
    ).concat(socketMiddleware),
    devTools:process.env.NODE_ENV !== "production"
})

export default store